import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Card, CardContent, TextField, Button, Typography } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import { useMediaQuery, useTheme } from '@mui/material';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import data from '../../config/institution.json';
import { makeStyles } from '@mui/styles';
import { validateAccount, validateTransferMessage } from '../../utils/regex/Regex';
import { initAccountData } from '../../utils/object/Account';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import { useDispatch } from 'react-redux';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';
import { initTransfer247MessageData } from '../../utils/object/Transfer247Message';
import { deleteAccents } from '../../utils/function/Function';
import { graphGetAllContractByCustomer } from '../../services/Contract';
import { showAlert } from '../../redux/create-actions/AlertAction';

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const container = { mt: 1, textAlign: 'left' };
const buttonSubmit = {
    color: Color.Button,
    backgroundColor: Color.Dangerous,
    '&:hover': { background: Color.Button, color: Color.Dangerous }
};

const useStyles = makeStyles(function (theme) {
    return {
        gridContainer: {
            [theme.breakpoints.up("sm")]: {
                paddingLeft: '100px',
                paddingRight: '100px'
            },
            [theme.breakpoints.up("md")]: {
                paddingLeft: '150px',
                paddingRight: '150px'
            },
            [theme.breakpoints.up("lg")]: {
                paddingLeft: '200px',
                paddingRight: '200px'
            },
            [theme.breakpoints.only("xl")]: {
                paddingLeft: '400px',
                paddingRight: '400px'
            },
        },
    };
});

export default function TransferForm(props) {
    const theme = useTheme();
    const classes = useStyles();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();

    const [contract, setContract] = useState(null);
    const [contractID, setContractID] = useState(null)
    const [listContract, setListContract] = useState([]);
    const [accountErrorText, setAccountErrorText] = useState('');
    const [account, setAccount] = useState(initAccountData(''));
    const [institution, setInstitution] = useState('');
    const [messageData, setMessageData] = useState(initTransfer247MessageData(''));
    const [messageErrorText, setMessageErrorText] = useState('');

    useEffect(() => {
        if (contractID !== null && listContract.length !== 0) {
            setContract(listContract.filter((e) => e.id === contractID)[0]);
        }
    }, [contractID, listContract])

    useEffect(() => {
        dispatch(openLoadingApi());
        const contractType = ['PREPAID']
        const promise = graphGetAllContractByCustomer(contractType);
        promise.then((result) => {
            setContractID(result.items[0].id);
            setListContract(result.items);
            dispatch(closeLoadingApi());
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error))
            console.log(err);
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    const handleChangeInstitution = (event) => {
        setInstitution(event.target.value);
    };

    const handleChangeAccount = (event) => {
        let value = event.target.value;
        let Data = handleValidateAccount(value);
        setAccount(Data);
    }

    function handleValidateMessage(message) {
        let result = validateTransferMessage(message);
        let data;
        if (!result) {
            data = { ...messageData, message: message, isTransfer247MessageError: true };
            setMessageData(data);
            setMessageErrorText("Please enter up to 200 characters");
        } else {
            data = { ...messageData, message: message, isTransfer247MessageError: false };
            setMessageData(data);
            setMessageErrorText("");
        }
        return data;
    }

    function handleValidateAccount(account) {
        let result = validateAccount(account);
        let Data;
        if (!result) {
            Data = { ...account, account: account, isAccountError: true };
            setAccount(Data);
            setAccountErrorText("Error Account Format");
        } else {
            Data = { ...account, account: account, isAccountError: false };
            setAccount(Data);
            setAccountErrorText("");
        }
        return Data;
    };

    const handleClick = (event) => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',

        };
        if (contract !== null && contractID !== null) {
            console.log(
                institution,
                account.account
            )
        } else {
            alert = { ...alert, message: "You don't have a prepaid card to transfer money" };
            dispatch(showAlert(alert))
        }
    };

    const renderOption = data.institutions.map((item, i) => {
        return (
            <MenuItem value={item.id} key={i}>{item.name + ' (' + item.code + ')'}</MenuItem>
        );
    });

    const handleChangeContract = (event) => {
        setContractID(event.target.value);
    };

    const handleChangeMessage = (event) => {
        let value = deleteAccents(event.target.value);
        if (value !== "") {
            let data = handleValidateMessage(value)
            setMessageData(data)
        } else {
            setMessageData({ ...messageData, message: '', isTransfer247MessageError: false })
            setMessageErrorText("")
        }
    }

    return (
        <Paper variant="outlined" sx={paperStyle}>
            <Grid container alignContent="center" justifyContent="space-between"  >
                <Grid item>
                    <Button id="transfer" endIcon={<MoveDownIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
                        Transfer
                    </Button>
                </Grid>
            </Grid>
            <Card>
                <CardContent>
                    <Grid container spacing={gridSpacing} className={classes.gridContainer} sx={container}>
                        <Grid item xs={12} sm={12} md={3}>
                            <Typography variant="h4"> From Account: </Typography>
                        </Grid>
                        <Grid item md={9} xs={12}>
                            <Select
                                fullWidth
                                labelId="cardnumberl-filter"
                                id="demo-simple-select-helper"
                                value={contractID ? contractID : null}
                                onChange={handleChangeContract}
                                size="medium"
                                sx={{
                                    '& .MuiInputBase-input': {
                                        bgcolor: theme.palette.background.default
                                    },
                                    bgcolor: theme.palette.background.default,
                                    textAlign: 'center'
                                }}
                            >
                                {(contract !== null && contractID !== null) ? (
                                    listContract?.map((contract) => {
                                        return (
                                            <MenuItem key={contract.id} id={contract.id} value={contract.id}>
                                                {(contract.contractNumber).slice(0, 4)}&emsp;{(contract.contractNumber).slice(4, 8).replace("__", "**")}&emsp;{(contract.contractNumber).slice(8, 12).replace("____", "****")}&emsp;{(contract.contractNumber).slice(12, 16)}
                                            </MenuItem>
                                        )
                                    })
                                ) : (
                                    <MenuItem value={null}>
                                        No Options
                                    </MenuItem>
                                )
                                }
                            </Select>
                        </Grid>
                        <Grid item sm={0} xs={0} md={3} xl={3}>
                            <Typography variant="h4"> To Instituition: </Typography>
                        </Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <FormControl
                                fullWidth>
                                <InputLabel id="demo-simple-select-helper-label">Institution</InputLabel>
                                <Select
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    value={institution}
                                    label="Product"
                                    onChange={handleChangeInstitution}
                                    sx={{
                                        '& .MuiInputBase-input': {
                                            bgcolor: theme.palette.background.default
                                        },
                                        bgcolor: theme.palette.background.default,
                                    }}
                                >
                                    {renderOption}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item sm={0} xs={0} md={3} xl={3}>
                            <Typography variant="h4"> To Account: </Typography>
                        </Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <TextField
                                fullWidth
                                required
                                id="account"
                                name="account"
                                label="To Account"
                                autoComplete="given-name"
                                variant="standard"
                                error={account.isAccountError}
                                helperText={accountErrorText}
                                onChange={handleChangeAccount}
                            ></TextField>
                        </Grid>
                        <Grid item sm={0} xs={0} md={3} xl={3}>
                            <Typography variant="h4"> Amount: </Typography>
                        </Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <TextField
                                fullWidth
                                required
                                id="amount"
                                name="amount"
                                label="Amount"
                                autoComplete="given-name"
                                variant="standard"
                                error={account.isAccountError}
                                helperText={accountErrorText}
                                onChange={handleChangeAccount}
                            ></TextField>
                        </Grid>
                        <Grid item sm={0} xs={0} md={3} xl={3}>
                            <Typography variant="h4">
                                Message:
                            </Typography>
                        </Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}>
                            <TextField
                                fullWidth
                                required
                                id="message"
                                name="message"
                                label="Message"
                                value={messageData.message}
                                error={messageData.isTransfer247MessageError}
                                variant="standard"
                                helperText={messageErrorText}
                                onChange={handleChangeMessage}
                            ></TextField>
                        </Grid>
                        <Grid item sm={0} xs={0} md={3} xl={3}></Grid>
                        <Grid item sm={12} xs={12} md={9} xl={9}
                            sx={{
                                textAlign: `${matchDownSM ? 'center' : 'left'}`,
                            }}>
                            <Button sx={buttonSubmit} variant="contained" endIcon={<MoveDownIcon></MoveDownIcon>}
                                onClick={handleClick}
                            >Transfer</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Paper>
    )
}